import { num } from './numbers';

/** Aging bucket colours: calm for current, warming up to red as debts get older. */
export const AGING_COLORS = {
  current: 'var(--mui-palette-success-main)',
  days1To30: 'var(--mui-palette-info-main)',
  days31To60: '#e0a100',
  days61To90: '#ef6c00',
  over90: 'var(--mui-palette-error-main)',
} as const;

export const AGING_BUCKETS = [
  { key: 'current', label: 'Not yet due' },
  { key: 'days1To30', label: '1–30 days' },
  { key: 'days31To60', label: '31–60 days' },
  { key: 'days61To90', label: '61–90 days' },
  { key: 'over90', label: 'Over 90 days' },
] as const;

/** Share of the outstanding total that is overdue (any bucket past due). */
export function overdueShare(
  totals: Record<(typeof AGING_BUCKETS)[number]['key'], string>,
): number {
  const all = AGING_BUCKETS.reduce((s, b) => s + num(totals[b.key]), 0);
  if (all <= 0) return 0;
  return (all - num(totals.current)) / all;
}
